export default {
    name: 'unitMeasurement',
    serverName: '/api/v1/unit_of_measurement/unit_of_measurement/',
    apiUrl: '/api/v1/unit_of_measurement/unit_of_measurement/'
};
